/*
 * Copyright (C) 2015 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import $ from 'jquery'
import {useScope as createI18nScope} from '@canvas/i18n'
import React from 'react'
import {legacyRender} from '@canvas/react'
import {Alert} from '@instructure/ui-alerts'
import ready from '@instructure/ready'

const I18n = createI18nScope('GroupSubmissionAlert')

interface GroupSubmissionAlertProps {
  groupType: string
}

export default function GroupSubmissionAlert({groupType}: GroupSubmissionAlertProps) {
  return (
    <Alert variant="warning" margin="medium 0">
      {I18n.t('Keep in mind, this submission will count for everyone in your %{groupType} group.', {
        groupType,
      })}
    </Alert>
  )
}

ready(() => {
  $('.group_submission_alert').each((_idx, alertContainer) => {
    legacyRender(
      <GroupSubmissionAlert groupType={alertContainer.getAttribute('data-group-type') || ''} />,
      alertContainer,
    )
  })
})
